import { FC, Fragment, useState } from "react";
import { Button, Form, Input } from "antd";
import { useAppDispatch, useAppSelector } from "../../store";
import { ArrowLeftOutlined, CheckOutlined } from "@ant-design/icons";
import { _recovery_access } from "../../store/actions/userAction";
import { addPlusToNumber, emailPattern, phoneValid } from "../../utils";
import { useNavigate } from "react-router-dom";
import styles from "./ForgotPassword.module.css";

const ForgotPassword: FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { _load_button, email } = useAppSelector(({ userSlice }) => userSlice);

  const [form] = Form.useForm();
  const [isSuccess, setIsSuccess] = useState(false);

  const onBackHandler = () => {
    navigate("/login");
  };

  const onSuccess = () => setIsSuccess(true);

  const onFinishHandler = () => {
    const value = form.getFieldValue("phone");

    const phone = phoneValid.test(value) ? value : undefined;

    dispatch(_recovery_access({ phone, onSuccess }));
  };

  const onPhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const phone = addPlusToNumber(e.target.value);

    form.setFieldsValue({ phone });
  };

  return (
    <div className={styles.container}>
      <div className={styles.modal}>
        <h2 className={styles.title}>Восстановление пароля</h2>
        <p className={styles.subtitle}>
          Введите номер, указанный в вашем профиле
        </p>
        <Form form={form} layout="vertical" onFinish={onFinishHandler}>
          <Form.Item
            name="phone"
            className={styles.formBlock}
            rules={[
              { required: true, message: "Введите номер телефона", min: 4 },
              {
                validator: (_, value) => {
                  if (
                    value &&
                    !phoneValid.test(value) &&
                    !emailPattern.test(value)
                  ) {
                    return Promise.reject("Неправильный формат номера");
                  }

                  return Promise.resolve();
                },
              },
            ]}
            hasFeedback
          >
            <Input
              className={styles.forgotInput}
              disabled={isSuccess}
              placeholder="Телефон"
              onChange={onPhoneChange}
            />
          </Form.Item>
          {!isSuccess && (
            <Fragment>
              <p className={styles.hint}>
                Ссылка для восстановления доступа будет отправлена на вашу
                электронную почту, указанную в профиле
              </p>
              <Form.Item shouldUpdate>
                {() => {
                  const value = form.getFieldValue("phone");

                  return (
                    <Button
                      type="primary"
                      htmlType="submit"
                      className={styles.nextButton}
                      loading={_load_button}
                      disabled={!value}
                      block
                    >
                      Восстановить пароль
                    </Button>
                  );
                }}
              </Form.Item>
            </Fragment>
          )}
          {isSuccess && (
            <div className={styles.notify}>
              <CheckOutlined />
              <p className={styles.notifyText}>
                Ссылка для восстановления пароля отправлена на email {email}
              </p>
            </div>
          )}
          <Button
            type="link"
            icon={<ArrowLeftOutlined />}
            className={styles.backButton}
            onClick={onBackHandler}
          >
            Назад к авторизации
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default ForgotPassword;
